export const PURCHASE_ORDER_DIVISION_PERMISSION = {
  VIEW: 'PURCHASE_ORDER_DIVISION_VIEW',
  ADD: 'PURCHASE_ORDER_DIVISION_ADD',
  EDIT: 'PURCHASE_ORDER_DIVISION_EDIT',
  DEL: 'PURCHASE_ORDER_DIVISION_DEL',
  REVIEW: 'PURCHASE_ORDER_DIVISION_REVIEW',
  ADD_NEW_REVIEW: 'PURCHASE_ORDER_DIVISION_ADD_NEW_REVIEW',
  ADD_USER_REVIEW: 'PURCHASE_ORDER_DIVISION_ADD_USER_REVIEW',
  ASSIGN_DESTINATION_STOCK: 'PURCHASE_ORDER_DIVISION_ASSIGN_DESTINATION_STOCK',
};

export const reviewTypeOptions = [
  {
    label: 'Chưa duyệt',
    colorLabel: 'bw_black',
    className: '',
    icon: 'fi-rr-minus',
    value: null,
  },
  {
    label: 'Đã duyệt',
    colorLabel: 'bw_green',
    className: 'bw_agree',
    icon: 'fi-rr-check',
    value: 1,
  },
  {
    label: 'Không duyệt',
    colorLabel: 'bw_red',
    className: 'bw_non_agree',
    icon: 'fi-rr-minus',
    value: 0,
  },
];

export const DIVISION_TYPES = {
  DIRECT_FROM_PURCHASE_ORDER: 0,
  FROM_STOCK: 1,
  PRE_ORDER_FROM_STOCK: 2,
};

export const BRANCH_TRANSFER_TYPES = {
  SAME_BRANCH: 0,
  DIFFERENT_BRANCH: 1,
};

export const BRANCH_TRANSFER_TYPE_OPTIONS = [
  { value: BRANCH_TRANSFER_TYPES.SAME_BRANCH, label: 'Cùng chi nhánh' },
  { value: BRANCH_TRANSFER_TYPES.DIFFERENT_BRANCH, label: 'Khác chi nhánh' },
];

export const DIVISION_DOCUMENT_TYPES = {
  INTERNAL_TRANSPORT_NOTE: 'internal_transport_note',
  INTERNAL_SALE_INVOICE: 'internal_sale_invoice',
};

export const DIVISION_DOCUMENT_TYPE_OPTIONS = [
  {
    value: DIVISION_DOCUMENT_TYPES.INTERNAL_TRANSPORT_NOTE,
    label: 'Phiếu xuất kho kiêm vận chuyển nội bộ',
  },
  {
    value: DIVISION_DOCUMENT_TYPES.INTERNAL_SALE_INVOICE,
    label: 'Hóa đơn GTGT nội bộ + Phiếu xuất kho kiêm vận chuyển nội bộ',
  },
];

export const DIVISION_PRICE_TYPES = {
  COST_PRICE: 'cost_price',
  OUTPUT_TYPE_PRICE: 'output_type_price',
};

export const DIVISION_PRICE_TYPE_OPTIONS = [
  {
    value: DIVISION_PRICE_TYPES.COST_PRICE,
    label: 'Lấy giá vốn tồn kho',
  },
  {
    value: DIVISION_PRICE_TYPES.OUTPUT_TYPE_PRICE,
    label: 'Lấy giá theo hình thức xuất',
  },
];
